import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ToastService} from './toast.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  toastService = inject(ToastService);
  router = inject(Router);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error.status === 401){
            this.toastService.error((error.error.errors) ? this.getErrors(error.error.errors) : 'Errore di autenticazione. Utente non autorizzato o token scaduto');
            switch (this.router.url.split('/')[1]){
              default:
                this.router.navigate(['login']);
            }
            return throwError(error);
        }
        else{
          return throwError(error);
        }
      })
    );
  }

  getErrors(errors: any): string{
      let response = '';
      const properties = Object.getOwnPropertyNames(errors);
      properties.forEach(element => {
        response = response + errors[element as keyof typeof errors][0] + '\n';
      });
      return(response);
  }
}
